import { juvareColors } from '@juvare/common-web-ui/JuvareTheme';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Divider, IconButton, Typography } from '@mui/material';
import { parseISO } from 'date-fns';
import React from 'react';
import { useInboxTranslation } from '../../Hooks';

export interface RowContentProps {
    dateReceived: string;
    title: string;
    isRead: boolean;
    onActionClick: () => void;
}

export const RowContent: React.FC<RowContentProps> = (props) => {
    const { t } = useInboxTranslation();
    const dateReceived = parseISO(props.dateReceived);
    return (
        <Box
            sx={{
                display: 'flex',
                p: 2,
                backgroundColor: props.isRead ? juvareColors.neutral[0] : juvareColors.neutral[50],
                '&:hover': {
                    backgroundColor: juvareColors.neutral[300],
                    transition: '150ms ease-in-out',
                },
                transition: '150ms ease-in-out',
            }}
            data-test='inbox-widget-row-content'
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', flexGrow: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: 'fit-content' }}>
                    <Typography fontSize={12} color={juvareColors.neutral[700]}>
                        {t('weekdayDate', { value: dateReceived }).toUpperCase()}
                    </Typography>
                    <Divider sx={{ height: '14px' }} orientation='vertical' flexItem variant='middle' />
                    <Typography fontSize={12} color={juvareColors.neutral[700]}>
                        {t('time', { value: dateReceived })}
                    </Typography>
                </Box>
                <Typography
                    sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                    variant='h6'
                    color={juvareColors.neutral[900]}
                >
                    {props.title}
                </Typography>
            </Box>

            <Box sx={{ alignSelf: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <IconButton color='primary' onClick={props.onActionClick}>
                    <ChevronRightIcon />
                </IconButton>
            </Box>
        </Box>
    );
};
